<template>
  <div>
    <!-- 导航 -->
    <el-breadcrumb>
      <el-breadcrumb-item>
        <router-link to="./">首页</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>用户管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 主体内容 -->
    <div class="content">
      <el-form
        inline
    
        label-position="right"
        label-width="60px"
        size="small"
        class="query-form"
      >
        <el-form-item label="搜索">
         <el-input v-model="query.key" @change="selList()" clearable placeholder="请输入关键词"></el-input>
        </el-form-item>
        <el-form-item label="角色" prop="roleID">
          <el-select
            v-model="query.roleID"
            placeholder="请选择"
            filterable
            clearable
            @change="selList()"
          >
            <el-option
              v-for="item in roList"
              :label="item.name"
              :value="item.id"
              :key="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="selList()">查询</el-button>
          <el-button type="success" @click="addClick">新增</el-button>
        </el-form-item>
      </el-form>
      <!-- 列表查询 -->
      <el-card class="box-card table">
        <div slot="header" class="clearfix">
          <span>用户列表</span>
        </div>
        <!-- 列表定义 -->
        <el-table
          v-loading="loading"
          :data="tableData"
          ref="tableData"
          border
          stripe
          style="width: 100%"
        >
          <el-table-column prop="userName" label="用户名"></el-table-column>
          <el-table-column prop="realName" label="真实姓名"></el-table-column>
 
          <el-table-column prop="phone" label="联系电话"></el-table-column>
          <el-table-column label="是否可用" prop="isEnable">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.isEnable" type="success">是</el-tag>
              <el-tag v-else type="warn">否</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="roleName" label="会员角色"></el-table-column>

          <el-table-column label="操作" width="80" fixed="right">
            <template slot-scope="scope">
              <el-button-group>
                <el-tooltip content="编辑" placement="top">
                  <el-button
                    type="primary"
                    size="mini"
                    icon="el-icon-edit"
                    @click="editClick(scope.row)"
                  ></el-button>
                </el-tooltip>
                <el-tooltip content="删除" placement="top">
                  <el-button
                    type="warning"
                    size="mini"
                    icon="el-icon-delete"
                    @click="delClick(scope.row)"
                  ></el-button>
                </el-tooltip>
                <el-tooltip content="重置登录密码" placement="top">
                  <el-button
                    type="danger"
                    size="mini"
                    icon="el-icon-lock"
                    @click="resetClick(scope.row)"
                  ></el-button>
                </el-tooltip>
              </el-button-group>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页条 -->
        <div class="block" style="margin-top: 20px">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage4"
            :page-sizes="[10, 20, 30, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes,prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </div>
      </el-card>
    </div>

    <!-- 操作对话框 -->
    <el-dialog
      :title="form.userID > 0 ? '编辑用户信息' : '添加用户信息'"
      :visible.sync="dialogVisible"
      width="720px"
    >
      <el-form
        :model="form"
        ref="form"
        label-width="100px"
        :status-icon="true"
        @submit.native.prevent="submitForm('form')"
      >
        <el-tabs v-model="formTab">
          <el-tab-pane label="基本信息" name="base">
            <el-form-item
              label="用户名"
              prop="userName"
              :rules="[{ required: true, message: '请输入用户名' }]"
            >
              <el-input
                v-model="form.userName"
                placeholder="请输入用户名，默认密码6个1"
              ></el-input>
            </el-form-item>

            <el-form-item label="真实姓名" prop="realName">
              <el-input
                v-model="form.realName"
                placeholder="请输入真实姓名"
              ></el-input>
            </el-form-item>

            <el-form-item
              label="性别"
              prop="sex"
              :rules="[{ required: true, message: '请输选择性别' }]"
            >
              <el-radio-group v-model="form.sex">
                <el-radio :v-model="true" :label="true">男</el-radio>
                <el-radio :v-model="false" :label="false">女</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item label="生日" prop="addTime">
              <el-date-picker
                v-model="form.addTime"
                type="date"
                placeholder="选择日期"
              ></el-date-picker>
            </el-form-item>

            <el-form-item label="联系电话" prop="phone">
              <el-input
                v-model="form.phone"
                placeholder="请输入联系电话电话"
              ></el-input>
            </el-form-item>

            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item
                  label="会员角色"
                  prop="roleID"
                  :rules="[{ required: true, message: '请选择会员角色' }]"
                >
                  <el-select
                    v-model="form.roleID"
                    placeholder="请选择会员角色"
                    filterable
                  >
                    <el-option
                      v-for="item in roList"
                      :label="item.name"
                      :value="item.id"
                      :key="item.id"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="20">
              <el-col :span="6">
                <el-form-item
                  label="是否可用"
                  :rules="[{ required: true, message: '请选择是否可用' }]"
                >
                  <el-switch v-model="form.isEnable"></el-switch>
                </el-form-item>
              </el-col>
            </el-row>
          </el-tab-pane>

          <el-tab-pane label="技能图" name="intro">
            <div style="color:#999;font-size:12px;margin-bottom:10px">
              上传 1 张技能介绍图，小程序点击后直接弹出预览
            </div>
            <div id="mgrSkillUpload" class="uploader uploader-warning"></div>
            <div v-if="form.content" style="margin-top:12px">
              <el-image
                style="width:160px;height:160px"
                fit="contain"
                :src="domain + form.content"
                :preview-src-list="[domain + form.content]"
              ></el-image>
              <div style="margin-top:8px">
                <el-button type="text" style="color:#f56c6c" @click="form.content = ''">清除</el-button>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>

        <el-form-item style="margin-top: 16px">
          <el-button type="primary" :loading="submiting" native-type="submit"
            >提交</el-button
          >
          <el-button @click="dialogVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import url from "@/plugins/urlHelper.js";
export default {
  data() {
    return {
      query:{key:''}, //对象
      loading: false,
      currentPage4: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      form: {}, //表单对象
      formTab: "base",
      dialogVisible: false,
      submiting: false,
      id: 0,
      roList: [], //角色列表
      domain: url.getDomain(),
    };
  },
  watch: {
    formTab(val) {
      if (val === "intro" && this.dialogVisible) {
        this.$nextTick(() => this.initSkillUpload());
      }
    },
    dialogVisible(val) {
      if (val && this.formTab === "intro") {
        this.$nextTick(() => this.initSkillUpload());
      }
    },
  },
  methods: {
    /** Content 存单图相对路径；兼容旧 JSON 数组 / 富文本取第一张 */
    parseSkillImg(content) {
      if (!content) return "";
      try {
        var arr = JSON.parse(content);
        if (Array.isArray(arr) && arr.length) {
          var x = arr[0];
          return typeof x === "string" ? x : (x && x.filePath) || "";
        }
      } catch (e) { /* 非 JSON */ }
      if (content.indexOf("src=") >= 0) {
        var m = /src=["']([^"']+)["']/i.exec(content);
        return m ? m[1] : "";
      }
      var t = (content || "").trim();
      if (t && t.indexOf("<") < 0) return t;
      return "";
    },
    initSkillUpload() {
      var _this = this;
      if ($("#mgrSkillUpload input").length > 0) return;
      $("#mgrSkillUpload").uploader({
        url: url.getUpload(),
        text: "上传技能图",
        fileExts: "jpg;png;jpeg",
        more: false,
        auto: true,
        handleType: "0",
        max: 1024 * 1024 * 5,
        onSuccess: function (data) {
          _this.$set(_this.form, "content", data.relativeName);
        },
      });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage4 = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      this.currentPage4 = val;
      this.getList();
    },
    //筛选
    filterTag(filter) {
      var val = filter["isEnable"][0];
      this.form.isEnable = val;
      //刷新列表
      this.getList();
    },
    //排序
    sortChange(sortColumn) {
      this.form.sort = sortColumn.prop;
      this.form.order = sortColumn.order;
      //刷新列表
      this.getList();
    },
    getList: function () {
      var _this = this;
      _this.loading = true;
      var params = _this.query;
      params.pageindex = _this.currentPage4;
      params.pagesize = _this.pageSize;
      var link = url.getSys("getlist_manager");
      $.get(link, params, (data) => {
        _this.loading = false;
        _this.tableData = data.list;
        _this.total = data.total;
      });
    },
    //角色列表
    roleList: function () {
      var _this = this;
      _this.loading = true;
      var params = _this.query;
      params.pageindex = 1;
      params.pagesize = 100;
      params.key = _this.key;
      var link = url.getSys("getlist_role");
      $.get(link, params, (data) => {
        _this.loading = false;
        _this.roList = data.list;
      });
    },
    //搜索查询
    selList: function () {
      this.currentPage4 = 1;
      this.getList();
    },
    //提交表单
    submitForm(formName) {
      var _this = this;
      var link = url.getSys("addorupdate_manager");
      var info = Object.assign({}, this.form);
      info.content = this.form.content || "";
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submiting = true;
          //提交后台添加
          //添加或者修改
          $.post(link, info, (res) => {
            _this.submiting = false;
            if (res.status) {
              _this.dialogVisible = false;
              _this.getList();
              _this.$message({
                type: "success",
                message: res.msg,
              });
            } else {
              _this.$message({
                type: "error",
                message: res.msg,
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    //新增
    addClick() {
      this.formTab = "base";
      this.form = { isEnable: true, content: "" };
      this.dialogVisible = true;
    },
    //编辑
    editClick: function (row) {
      this.formTab = "base";
      this.form = Object.assign({}, row);
      this.form.content = this.parseSkillImg(row.content);
      this.dialogVisible = true;
    },
    //删除
    delClick: function (row) {
      var _this = this;
      var link = url.getSys("delete_manager"); //获取请求地址
      var id = row.userID; //获取对象id

      this.$confirm("确定要删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          $.post(link, { idList: id }, (res) => {
            _this.btnLoading = false;
            if (res.status) {
              _this.msg = res;
              _this.getList();
              this.$message({
                type: "success",
                message: "删除成功!",
              });
            } else {
                this.$message({
                type: "error",
                message: res.msg,
              });
            }

          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //重置登录密码
    resetClick: function (row) {
      var _this = this;
      var link = url.getSys("resetpwd"); //获取请求地址
      var id = row.userID; //获取对象id

      this.$confirm("确定要重置吗，数据将不可恢复？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          $.post(link, { id: id, pwd: "111111" }, (res) => {
            _this.btnLoading = false;
            if (res.status) {
              _this.$message({
                type: "success",
                message: res.msg,
              });
            } else {
              _this.$message({
                type: "error",
                message: res.msg,
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
  },
  mounted() {
    //获取服务器列表
    this.getList();
    //获取角色列表
    this.roleList();
  },
};
</script>

<style>
.query-form {
  margin-top: 20px;
  padding-top: 25px;
  background: #f2f2f2;
}
.el-form-item--small.el-form-item {
  margin-right: 0px;
}
.el-button--primary {
  margin-left: 10px;
}
</style>
